import { DataTable } from '../../../../../components/UI/MDC/DataTable/DataTable';
import { GetNotificationTypes } from '../_constants';
import NotificationRecipientsUpdate from './NotificationRecipientsUpdate';
import CreateEventButton from './CreateEventButton';

const NotificationUpdate = ({
	notifications,
	setAppNotifications,
	appID,
	currentUser,
	readOnly,
	requirementNumber,
	multiWorkQueueNotifications,
}) => {
	const headers = [
		{ Value: 'Description', props: { sort: null, onSortChange: null } },
		{ Value: 'Event ID', props: { sort: null, onSortChange: null } },
		{ Value: 'Action ID', props: { sort: null, onSortChange: null } },
		{ Value: 'Recipients', props: { sort: null, onSortChange: null } },
		{ Value: 'Actions', props: { sort: null, onSortChange: null } },
	];

	const selectNotificationByType = notificationType => {
		let selectedNotification = notifications?.find(notification => {
			return (
				notification.actionID === notificationType.actionID &&
				notification.eventTypeID === notificationType.eventTypeID
			);
		});
		if (selectedNotification) {
			return selectedNotification;
		}
	};

	const rows = GetNotificationTypes(multiWorkQueueNotifications).map(
		(x, index) => {
			const appNotification = selectNotificationByType(x);

			//if notifications prop does not contain a record for the given notification type, render a button where on click it will send the api request to create the TS_Event_Matrix entry for the selected app and notification type
			const actionComponent = appNotification ? (
				<NotificationRecipientsUpdate
					notificationEvent={appNotification}
					notificationDescription={x.name}
					setAppNotifications={setAppNotifications}
					appNotifications={notifications}
					notificationType={x}
					disabled={readOnly}
					requirementNumber={requirementNumber}
				/>
			) : (
				<CreateEventButton
					eventType={x}
					appID={appID}
					currentUser={currentUser}
					setAppNotifications={setAppNotifications}
					disabled={readOnly}
					requirementNumber={requirementNumber}
				/>
			);

			return {
				Cells: {
					Description: {
						Value: x.name,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					'Event ID': {
						Value: x.eventTypeID,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					'Action ID': {
						Value: x.actionID,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					Recipients: {
						Value: appNotification?.recipients,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					Actions: {
						Value: actionComponent,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
				},
				Key: index.toString(),
			};
		}
	);

	return (
		<div>
			<DataTable rows={rows} headers={headers} />
		</div>
	);
};

export default NotificationUpdate;
